export default (count: number) => {
  const ar = new Array<number>(count);
  for (let i = 0; i < count; i++) {
    ar[i] = i;
  }
  return ar;
};
